import Vue from 'vue';

const state = {
    user: {
        name: '',
        email: ''
    },
    agency: {
        nummer: '',
        strasse: '',
        fax: '',
        email: '',
        hpName: '',
        tel: '',
        name: '',
        ort: '',
        plz: '',
        kanalType: '',
        firma: ''
    },
    topics: [
        {
            index: '1',
            sortOrder: 3,
            label: 'Absicherung'
        },
        {
            index: '2',
            sortOrder: 6,
            label: 'Gesundheit'
        },
        {
            index: '3',
            sortOrder: 1,
            label: 'Haftung & Recht'
        },
        {
            index: '4',
            sortOrder: 5,
            label: 'Haus & Wohnen'
        },
        {
            index: '5',
            sortOrder: 2,
            label: 'Mobilität'
        },
        {
            index: '6',
            sortOrder: 4,
            label: 'Vorsorge & Sparen'
        },
        {
            index: '7',
            sortOrder: 7,
            label: 'Weiteres'
        }
    ],
    products: [
        {
            col: 'f',
            icon: 'car-insurance-hands',
            label: 'Kfz-Schutz',
            topic: '5',
            checked: true,
            decision: '',
            info: 'Ohne Haftpflichtversicherung geht nichts – sie ist eine echte Pflichtversicherung! Denn sie ist für Dich ist da, wenn es richtig teuer wird, und kommt für die Schäden auf, die Du an anderen Fahrzeugen, Personen und weiteren Dingen verursacht hast. Gleichzeitig übernimmt sie auch die Abwehr unberechtigter Ansprüche. Darüber hinaus kannst Du weitere wichtige Sicherheitspakete erwerben und setzt so auf Rundumschutz ohne Lücken.'
        },
        {
            col: 'g',
            icon: 'sea-transport-yacht',
            label: 'Sportboot&shy;haftpflicht',
            topic: '5',
            info: 'Wer als Freizeitkapitän anderen z. B. mit seinem Sportboot einen Schaden zufügt, haftet für diesen im vollen Umfang. Versichert ist hier Deine gesetzliche Haftpflicht aus dem Halten, dem Besitz und dem Gebrauch von Wassersportfahrzeugen, die ausschließlich zu privaten Zwecken oder zur gelegentlichen privaten Vermietung genutzt werden – ohne Berufsbesatzung.'
        },
        {
            col: 'h',
            icon: 'dog-head',
            label: 'Hundehaftpflicht',
            topic: '3',
            info: 'Als Halter von Hunden bist Du gemäß den gesetzlichen Bestimmungen immer verantwortlich, wenn Dein Tier einen Schaden anrichtet. Ob Du im Einzelfall wirklich Schuld hast, spielt keine Rolle. Egal wie hoch der Schaden ist, Du haftest mit Deinem gesamten vorhanden und zukünftigen Vermögen, ein Leben lang. Wir nehmen Dir dieses Risiko ab. Übrigens ist diese Absicherung eine Pflichtversicherung per Gesetz.'
        },
        {
            col: 'i',
            icon: 'outdoors-horse',
            label: 'Pferdehaftpflicht',
            topic: '3',
            info: 'Als Halter von Pferden bist Du gemäß den gesetzlichen Bestimmungen immer verantwortlich, wenn Dein Tier einen Schaden anrichtet. Ob Du im Einzelfall wirklich Schuld hast, spielt keine Rolle. Egal wie hoch der Schaden ist, Du haftest mit Deinem gesamten vorhanden und zukünftigen Vermögen, ein Leben lang. Wir nehmen Dir dieses Risiko ab.'
        },
        {
            col: 'j',
            icon: 'deer-body',
            label: 'Jagdhaftpflicht',
            topic: '3',
            info: 'Damit Du Deiner Passion, der Hege und Pflege, in Wald und Flur nachgehen kannst, benötigst Du laut Bundesjagdgesetz eine Jagd-Haftpflicht. Unsere erstklassige Jagd-Haftpflichtversicherung bietet ein Rundum-Sorglos-Paket, das Dich bei allen jagdlichen Betätigungen schützt und natürlich auch Deine Jagdhunde.'
        },
        {
            col: 'k',
            icon: 'drone-mail',
            label: 'Drohnenhaftpflicht',
            topic: '3',
            info: 'Eine Haftpflichtversicherung für den Betrieb eines Fluggerätes – also auch einer Drohne – ist in Deutschland gesetzlich vorgeschrieben – unabhängig davon, ob die Drohne gewerblich oder rein privat als Hobby genutzt wird.<br>' +
                'Der Pilot der Drohne haftet für alle Schäden, die durch sein Flugmodell verursacht werden. Ein Beispiel hierfür wäre, dass die Drohne versehentlich in die gläserne Terrassentür des Nachbarhauses gesteuert wird und diese zerbricht. Wir übernehmen diese Kosten für Dich.'
        },
        {
            col: 'l',
            icon: 'pets-hospital',
            label: 'Tierkrankenversicherung',
            topic: '7',
            info: 'Schütze Deinen Vierbeiner mit der Krankenversicherung für Haustiere. Die Krankenversicherung für Tiere übernimmt bestimmte Kosten beim Tierarzt oder in der Tierklinik, wenn Dein Tier nicht gesund ist.'
        },
        {
            col: 'm',
            icon: 'legal-scale-document',
            label: 'Rechtsschutz',
            topic: '3',
            info: 'Du streitest Dich nicht? Trotzdem kann es passieren, dass Du in einen Streit verwickelt wirst. Egal ob Nachbarschaftsstreitigkeiten, Unstimmigkeiten nach Verkehrsunfällen, Reklamationen nach Urlaubsreisen oder arbeitsrechtliche Auseinandersetzungen – immer häufiger treffen sich die streitenden Parteien vor Gericht. Wir helfen Dir und übernehmen im Falle eines Rechtsstreits die Kosten für Anwälte, Gerichte, Sachverständige, Zeugen, Reisekosten, Dolmetscherkosten im Ausland. Falls erforderlich, übernehmen wir auch die Kosten der Gegenseite.'
        },
        {
            col: 'n',
            icon: 'ambulance-helicopter',
            label: 'Auslands&shy;krankenschutz',
            topic: '2',
            info: 'Die Auslandsreisekrankenversicherung für Urlaubsreisen und längere Auslandsaufenthalte. Mit der Auslandsreise-Krankenversicherung im Gepäck bist Du auch auf Reisen medizinisch bestens versorgt. Wähle zwischen dem Einmalschutz oder einer ganzjährigen Absicherung Deiner Urlaubsreisen. Du willst für längere Zeit ins Ausland – für Work and Travel, ein Auslandsstudium, als Expat oder digitaler Nomade? Mit GesundheitGLOBAL bist Du bis zu 5 Jahre abgesichert.'
        },
        {
            col: 'o',
            icon: 'disability-wheelchair',
            label: 'Pflegeschutz',
            topic: '2',
            info: 'Mit einer privaten Pflegezusatzversicherung schützt Du Dich vor hohen Pflegekosten. Denn grundsätzlich gilt: Wer in Deutschland krankenversichert ist, muss auch eine Pflegepflichtversicherung abschließen. Diese deckt aber nur einen Teil der Kosten ab. Im Pflegefall entsteht immer eine Lücke zwischen den tatsächlichen Aufwendungen und den Leistungen der Pflegepflichtversicherung.'
        },
        {
            col: 'p',
            icon: 'dentistry-tooth',
            label: 'Zahnschutz',
            topic: '2',
            info: 'Die Zahnschutz-Tarife für Kinder und Erwachsene enthalten je nach Wahl umfassende Leistungen:<br>' +
                '<strong>Zahnbehandlung und Zahnersatz</strong>: Ergänzende Leistungen zur GKV (Gesetzliche Krankenversicherung) für Kronen, Brücken und Prothesen, Inlays und Onlays sowie Implantate<br>' +
                '<strong>Zahnprophylaxe</strong>: Finanzielle Unterstützung bei der Zahnvorsorge, professionellen Zahnreinigung, Kunststofffüllungen, Inlays und Onlays<br>' +
                '<strong>Kieferorthopädie</strong>: Leistungen für Kinder und Erwachsene im Premium-Tarif'
        },
        {
            col: 'q',
            icon: 'medical-hospital-1',
            label: 'Heilpraktiker&shy;leistungen',
            topic: '2',
            info: 'Erhalte Zuschüsse für Maßnahmen durch Heilpraktiker und Ärzte bei Naturheilkunde, Osteopathie, Massagen und der Traditionellen Chinesischen Medizin (TCM).'
        },
        {
            col: 'r',
            icon: 'glasses-ski-2',
            label: 'Gesundheit/Brille',
            topic: '2',
            info: 'Profitiere mit der Zusatzversicherung von folgenden Leistungen zur Gesundheitsvorsorge:<br>' +
                '<strong>Vorsorgeuntersuchungen</strong>: Zur Früherkennung von Krankheiten<br>' +
                '<strong>Impfungen und Malariaprophylaxe</strong>: Für Inland- und Reiseschutzimpfungen<br>' +
                '<strong>Brillen und Kontaktlinsen</strong>: Inklusive Reparatur<br>' +
                '<strong>Refraktive Chirurgien</strong>: Korrigierende Augenoperationen zur Verbesserung der Sehfähigkeit<br>' +
                '<strong>Hörhilfen</strong>: Inklusive Reparatur'
        },
        {
            col: 's',
            icon: 'insurance-hand',
            label: 'Krankentagegeld',
            topic: '1',
            info: 'Die Dauer einer Krankheit oder ein Unfall lassen sich nicht planen. Solltest Du tatsächlich länger ausfallen, zahlt Dein Arbeitgeber Dir sechs Wochen das volle Gehalt weiter. Danach gleicht Dir diese Krankentagegeldversicherung das fehlende Einkommen aus.'
        },
        {
            col: 't',
            icon: 'hospital-bedroom-nurse',
            label: 'Krankenhaus&shy;behandlung',
            topic: '2',
            info: 'Ergänze die Leistungen der gesetzlichen Krankenversicherung durch die Krankenhauszusatzversicherung: Mit freier Wahl der Klinik, besserer Zimmerunterkunft und Arztwahl (Chefarzt oder Oberarzt).'
        },
        {
            col: 'u',
            icon: '/medical-personnel-doctor',
            label: 'Krankenvoll&shy;versicherung',
            topic: '2',
            info: 'Informiere Dich jetzt als Arbeitnehmer, Selbstständiger, Beamtenanwärter oder Beamter über die Private Krankenversicherung (PKV) und profitiere so von der Behandlung als Privatpatient beim Arzt und Zahnarzt.'
        },
        {
            col: 'v',
            icon: 'bandage-shoulder',
            label: 'Unfallversicherung',
            topic: '1',
            info: 'Unfallversicherung – alle fünf Sekunden passiert ein Unfall... nur wenige sind dann versichert. Mit unserer privaten Unfallversicherung bist Du 24 Stunden am Tag abgesichert, ob im Beruf oder in der Freizeit, zu Hause oder im Ausland. Wusstest Du eigentlich, dass über 70 Prozent der Unfälle in der Freizeit passieren? Und die „Gesetzliche“ zahlt keinen Cent. Wir helfen Dir, diese Lücke zu schließen.'
        },
        {
            col: 'w',
            icon: 'multiple-actions-shield',
            label: 'Privathaftpflicht',
            topic: '3',
            info: 'Ohne eine kleine Portion Risikobereitschaft macht das Leben nur halb so viel Spaß. Leichtsinn im großen Stil können sich jedoch die wenigsten Menschen leisten. Die Haftpflichtversicherung kommt für Schäden auf, die Du anderen versehentlich zufügst. Gleichzeitig übernimmt sie auch die Abwehr unberechtigter Ansprüche, falls Du dir gar nichts zu Schulden kommen lassen hast, ein Dritter das jedoch anders sieht.'
        },
        {
            col: 'x',
            icon: 'heavy-equipment-lift-hook-box',
            label: 'Bauherrenschutz',
            topic: '3',
            info: 'Auf einer Baustelle lauern viele Gefahren wie die offene Baugrube, Kellerschächte oder Gerüste. Außerdem hantieren täglich viele Menschen mit Werkstoffen und Werkzeugen. Entsprechend groß ist das Risiko, dass auch unbeteiligte Personen zu Schaden kommen können. Kommt es zu einem Unfall, haftest Du als Bauherr für Personen- und Sachschäden: Ein Rundum-Sorglos-Paket“ für Bauherren gibt es leider nicht, wohl aber Versicherungsschutz, der das Risiko überschaubar hält.'
        },
        {
            col: 'y',
            icon: 'kitchen-storage',
            label: 'Hausratschutz',
            topic: '4',
            info: 'Die Wohnungseinrichtung ist Ausdruck individueller Lebensart. Und auch die ganz alltäglichen Helferlein sind wichtiger Bestandteil Deines Hausrats. Eine Faustformel: Alles was rausfallen würde, wenn du das Dach deines Haus wegnehmen und es umdrehen würdest, gehört zum Hausrat. Umso überraschender ist es, dass viele Menschen den materiellen Wert ihrer Einrichtung deutlich unterschätzen. Das böse Erwachen kommt erst, wenn die Einrichtung ganz oder teilweise durch z. B. ein Feuer oder austretendes Leitungswasser zerstört wird. Im Schadenfall erhältst Du von uns den Hausrat zum Neuwert ersetzt.'
        },
        {
            col: 'z',
            icon: 'house-fire-1',
            label: 'Gebäudeschutz',
            topic: '4',
            info: 'Mit unserem GebäudeSchutz sicherst Du Dein Haus bestens ab, denn im Schadenfall bekommst Du unbürokratische und schnelle Hilfe. Wir garantieren Dir eine umfassende finanzielle Sicherheit, schon ab dem kleinsten Schaden. Im schlimmsten Fall kannst Du Dein Gebäude sogar zum aktuellen Neuwert wieder komplett aufbauen lassen, von der Bodenplatte bis zum Dach!'
        },
        {
            col: 'aa',
            icon: 'architecture-window-1',
            label: 'Haushaltglas',
            topic: '4',
            info: 'Die Glasversicherung schützt Dich vor den finanziellen Folgen der Beschädigung oder Zerstörung fertig eingesetzter oder montierter Scheiben, Platten und Spiegeln aus Glas oder auch künstlerisch bearbeiteter Glasscheiben, -platten und -spiegel. Aber auch der Bruch Deines Ceranfeldes ist hier abgesichert.'
        },
        {
            col: 'ab',
            icon: 'architecture-window',
            label: 'Gebäudeglas',
            topic: '4',
            info: 'Um Glasschäden umfassend abzusichern, kannst Du Deine Wohngebäudeversicherung um den Zusatzbaustein Glas+ erweitern. Der Grundschutz versichert festverbaute Fenster und Türen bei Schäden durch die entsprechenden versicherten Gefahren. Wird Glas beispielsweise durch Zugluft oder Vandalismus beschädigt, fällt das in der Regel nicht unter den Schutz der Gebäudeversicherung. Ist Glasbruch hingegen mitversichert, leisten wir– mit Ausnahme von Vorsatz des Versicherungsnehmers – unabhängig von der Schadensursache.'
        },
        {
            col: 'ac',
            icon: 'location-user',
            label: 'Grundstücks&shy;haftpflicht',
            topic: '3',
            info: 'Dinge wie herabfallende Dachziegel, lose Pflastersteine oder schlecht geräumte Fußwege im Winter können dazu führen, dass sich Personen verletzen oder z. B. parkende Autos beschädigt werden. Als Eigentümer eines Grundstückes oder Gebäudes haftest Du für derartige Schadenfälle, da du automatisch der Verkehrssicherungspflicht unterliegst. Die Kosten übernimmt die Haus- und Grundbesitzerhaftpflicht für Dich.'
        },
        {
            col: 'ad',
            icon: 'car-dashboard-fuel',
            label: 'Gewässerschäden',
            topic: '3',
            info: 'Öltankinhaber sind laut Wasserhaushaltsgesetz für Schäden an Grund- und Fließgewässern verantwortlich, die durch auslaufendes Öl aus ihren Anlagen verursacht werden. Die Schuldfrage ist dabei völlig belanglos.<br>' +
                'Wenn Öl austritt, bist Du verpflichtet, den entstandenen Schaden zu beseitigen. Die anfallenden Kosten fürs Ausbaggern, Abfahren und Verbrennen des ölverschmutzten Erdreichs sowie für die Reinigung von verschmutzten Gewässern trägst Du. Die Gewässerschaden-Haftpflichtversicherung übernimmt für Dich diese Kosten.'
        },
        {
            col: 'ae',
            icon: 'natural-disaster-bolt',
            label: 'Photovoltaikschutz ',
            topic: '4',
            info: 'Die Stromerzeugung mit Hilfe von Solarzellen ist eine der regenerativen Energien. Für die Einspeisung ins Stromnetz erhält der Betreiber einer Photovoltaikanlage von den Energieversorgungsunternehmen jährlich eine gesetzlich festgelegte Einspeisevergütung.<br>' +
                'Gegen die finanziellen Verluste durch Schäden an der Anlage oder den Verlust durch Diebstahl und den Ertragsausfall kannst Du Dich mit unserem Zusatzpaket zum GebäudeSchutz Photovoltaik+ absichern.'
        },
        {
            col: 'af',
            icon: 'common-file-text-home',
            label: 'Bausparen',
            topic: '6',
            info: 'Für die einen bedeutet ein Eigenheim Freiheit und endlich genug Platz, um sich ganz zu entfalten. Für andere ist es einfach eine sichere Investition. Es gibt viele gute Gründe für den Kauf oder Bau eines eigenen Zuhauses. Und es gibt einen Weg zur Finanzierung Deines Eigenheims, der besonders sicher ist: Bausparen.'
        },
        {
            col: 'ag',
            icon: 'bicycle-lock-key',
            label: 'Fahrraddiebstahl',
            topic: '5',
            info: 'Nach wie vor werden in Deutschland eine große Anzahl von Fahrrädern gestohlen und die Aufklärungsquote ist gering. <br>' +
                'Mit dem Zusatzbaustein zur Hausratversicherung bist Du abgesichert, wenn Dein Fahrrad gestohlen wird, egal ob es vor deiner Haustür steht oder Du gerade unterwegs bist – natürlich muss es abgeschlossen sein.'
        },
        {
            col: 'ah',
            icon: 'saving-safe-open',
            label: 'Wertsachenschutz',
            topic: '4',
            info: 'Die Hausratversicherung ersetzt auch Schäden an Wertsachen, etwa wenn Dir Schmuck oder andere wertvolle Gegenstände bei einem Wohnungseinbruch gestohlen worden ist. Für die Schäden gilt eine Höchstgrenze, diese liegt meist bei mindestens 20 Prozent der Versicherungssumme.<br>' +
                'Besitzt Du sehr teure Gegenstände, kannst Du höhere Obergrenzen vereinbaren.'
        },
        {
            col: 'ai',
            icon: 'saving-piggy-bank',
            label: 'Altersvorsorge',
            topic: '6',
            info: 'Gesetzliche Rente, Betriebsrente, Riester- oder Rürup-Rente? Oder doch die klassische Lebensversicherung, Aktienfonds oder Immobilien? Für die Altersvorsorge gibt es viele Möglichkeiten. Dabei den Durchblick zu behalten, fällt schwer. Trotzdem ist es wichtig, sich mit dem Thema auseinanderzusetzen. Denn am Ende steht immer die Frage: Reicht die Rente, um einen gewissen Lebensstandard im Alter zu sichern?<br>' +
                'Von der privaten Rentenversicherung bis zur Rürup-Rente – unsere privaten Altersvorsorgemodelle bieten finanzielle Sicherheit für Deine Zukunft.'
        },
        {
            col: 'aj',
            icon: 'business-piggy-bank-broken',
            label: 'Berufsunfähig&shy;keitsschutz',
            topic: '1',
            info: 'Das regelmäßige berufliche Einkommen ist der entscheidende Baustein für Deine Zukunft und die Versorgung Deiner Familie. Durch Krankheit oder Unfall kann Deine Arbeitsfähigkeit beeinträchtigt werden oder ganz verloren gehen. Damit kann die Grundlage für Deine Pläne und Wünsche in Frage gestellt sein. Durch die Zahlung der vereinbarten Rente erhältst Du Dir Deinen Lebensstandard.'
        },
        {
            col: 'ak',
            icon: 'christmas-angel',
            label: 'Lebens&shy;versicherung',
            topic: '1',
            info: 'Optimaler Hinterbliebenenschutz vom ersten Tag an - Der Verlust eines geliebten Menschen trifft die Angehörigen immer schwer. Durch den plötzlichen Verlust können hohe finanzielle Belastungen drohen. Eine Risiko-Lebensversicherung dient der finanziellen Absicherung des Partners, der Familie, von Firmenteilhabern, der Immobilienfinanzierung oder zur Kreditsicherung.'
        },
        {
            col: 'al',
            icon: 'laptop-shield',
            label: 'Digitalschutz',
            topic: '7',
            info: 'Heutzutage sind wir nahezu ständig online und haben Zugriff auf unsere Daten –  Hacker, Diebe und Betrüger allerdings auch. Fast jeder zweite Internetnutzer wurde bereits Opfer von Computerviren, Datendiebstahl, gehackten Accounts oder Onlinebetrug. Cyberkriminalität nimmt zu und die Täter werden immer professioneller. Mit unserem DigitalSchutz stehen wir Dir als Privatperson im Fall der Fälle zur Seite.'
        },
        {
            col: 'am',
            icon: 'accounting-bill-stack-1',
            label: 'Rücklagen',
            topic: '6',
            info: 'Es gibt sicherlich viele Dinge für die Du in Zukunft Geld benötigst. Es gibt aber auch viele Möglichkeiten, das Geld dafür gewinnbringend anzulegen. Du solltest Dir die Frage stellen, wieviel Rücklagen benötige ich bis wann und welche Anlageform kommt dafür jeweils in Frage. Wir helfen die gerne bei der Beantwortung.'
        },
        {
            col: 'an',
            icon: 'accounting-coins',
            label: 'Finanzierung',
            topic: '7',
            info: 'Lass Deine aufgeschobenen Wünsche endlich wahr werden. Mit einem Ratenkredit erfüllst Du Dir Deine Wünsche sofort und das mit monatlichen Raten, die Dich garantiert ruhig schlafen lassen. <br>' +
                'Ob Neubau oder Bestandsimmobilie, was immer Du vorhast – mit uns kannst Du bauen, kaufen und modernisieren. Gemeinsam finden wir die passende Lösung.'
        }
    ],
    out: [
        {
            index: "1",
            icon: 'Content - Content-Creation - content-pen-write',
            name: 'name',
            question: {
                text: {
                    young: 'Wie ist Dein Name?',
                    personal: 'Wie ist Dein Name?',
                    formal: 'Wie ist Dein Name?'
                }
            },
            options: {
                type: 'input',
                expected: 'text'
            },
            prevIndexString: "",
            currIndexString: "1",
            nextIndexString: "2"
        },
        {
            index: "2",
            icon: 'Family-Babies-Kids Babies baby-stork',
            name: 'birth',
            question: {
                text: {
                    young: 'In welchem Jahr bist Du geboren?',
                    personal: 'In welchem Jahr bist Du geboren?',
                    formal: 'In welchem Jahr bist Du geboren?'
                }
            },
            options: {
                type: 'input',
                expected: 'year'
            },
            prevIndexString: "1",
            currIndexString: "2",
            nextIndexString: "3"
        },
        {
            index: "3",
            icon: '',
            cloud: {
                iconDefault: '',
                iconByAnswer: ['','']
            },
            name: 'family-status',
            question: {
                text: {
                    young: 'Wie ist Dein Beziehungsstatus?',
                    personal: 'Wie ist Dein Beziehungsstatus?',
                    formal: 'Wie ist Dein Beziehungsstatus?'
                }
            },
            options: {
                type: 'select',
                expected: 'singleChoice',
                items: [
                    {
                        index: "3.1",
                        selected: false,
                        icon: 'Users - Geometric-Full-Body-Single-User-Neutral - single-neutral',
                        name: 'single',
                        label: {
                            young: 'Single',
                            personal: 'Single',
                            formal: 'Single'
                        },
                        points: {
                            m: 1,
                            v: 10,
                            w: 50,
                            ai: 10,
                            aj: 10,
                            al: 5
                        }
                    },
                    {
                        index: "3.2",
                        selected: false,
                        icon: 'Romance Wedding wedding-bride-groom',
                        name: 'married',
                        label: {
                            young: 'Partnerschaft/Ehe',
                            personal: 'Partnerschaft/Ehe',
                            formal: 'Partnerschaft/Ehe'
                        },
                        points: {
                            m: 2,
                            v: 10,
                            w: 50,
                            ai: 10,
                            aj: 10,
                            ak: 10,
                            al: 5
                        }
                    }
                ]
            },
            prevIndexString: "2",
            currIndexString: "3",
            nextIndexString: "4"
        },
        {
            index: "4",
            icon: '',
            cloud: {
                iconDefault: '',
                iconByAnswer: ['']
            },
            name: 'kids',
            question: {
                text: {
                    young: 'Hast Du Kinder?',
                    personal: 'Hast Du Kinder?',
                    formal: 'Hast Du Kinder?'
                }
            },
            options: {
                type: 'select',
                expected: 'singleChoice',
                items: [
                    {
                        index: "4.1",
                        selected: false,
                        icon: 'Entertainment-Event-Hobbies - Party - party-balloon',
                        name: 'noKids',
                        label: {
                            young: 'Keine Kinder',
                            personal: 'Keine Kinder',
                            formal: 'Keine Kinder'
                        },
                        points: {
                        }
                    },
                    {
                        index: "4.2",
                        selected: false,
                        icon: 'Users - Geometric-Close-Up-Single-User-Actions-Man - single-man-actions',
                        name: 'oneKid',
                        label: {
                            young: 'Ein Kind',
                            personal: 'Ein Kind',
                            formal: 'Ein Kind'
                        },
                        points: {
                            m: 1,
                            v: 10,
                            w: 5,
                            y: 5,
                            aa: 1,
                            ag: 5,
                            aj: 30,
                            ak: 30,
                            al: 10
                        }
                    },
                    {
                        index: "4.3",
                        selected: false,
                        icon: 'Users - Geometric-Close-Up-Multiple-Users - multiple-man',
                        name: 'twoKids',
                        label: {
                            young: 'Zwei Kinder',
                            personal: 'Zwei Kinder',
                            formal: 'Zwei Kinder'
                        },
                        points: {
                            m: 1,
                            v: 10,
                            w: 5,
                            y: 5,
                            aa: 1,
                            ag: 5,
                            aj: 30,
                            ak: 30,
                            al: 15
                        }
                    },
                    {
                        index: "4.4",
                        selected: false,
                        icon: 'Family-Babies-Kids - Family - family-add-new-member',
                        name: 'moreKids',
                        label: {
                            young: 'Mehr als zwei',
                            personal: 'Mehr als zwei',
                            formal: 'Mehr als zwei'
                        },
                        points: {
                            m: 1,
                            v: 10,
                            w: 5,
                            y: 5,
                            aa: 1,
                            ag: 5,
                            aj: 30,
                            ak: 30,
                            al: 20
                        }
                    }
                ]
            },
            prevIndexString: "3",
            currIndexString: "4",
            nextIndexString: "5"
        },
        {
            index: "5",
            icon: '',
            name: 'housing-conditions',
            question: {
                text: {
                    young: 'Wie ist Deine Wohnsituation?',
                    personal: 'Wie ist Deine Wohnsituation?',
                    formal: 'Wie ist Deine Wohnsituation?'
                }
            },
            options: {
                type: 'select',
                expected: 'singleChoice',
                items: [
                    {
                        index: "5.1",
                        selected: false,
                        icon: 'Building-Construction - Buildings - buildings-1',
                        name: 'rent',
                        label: {
                            young: 'Miete',
                            personal: 'Miete',
                            formal: 'Miete'
                        },
                        points: {
                            m: 3,
                            w: 3,
                            y: 20,
                            aa: 10,
                            af: 5
                        }
                    },
                    {
                        index: "5.2",
                        selected: false,
                        icon: 'Building-Construction Buildings building-1',
                        name: 'condo',
                        label: {
                            young: 'Eigentumswohnung',
                            personal: 'Eigentumswohnung',
                            formal: 'Eigentumswohnung'
                        },
                        childQuestions: [
                            {
                                index: "5.2.1",
                                icon: '',
                                name: '',
                                question: {
                                    text: {
                                        young: 'Ist die Wohnung finanziert?',
                                        personal: 'Ist die Wohnung finanziert?',
                                        formal: 'Ist die Wohnung finanziert?',
                                    }
                                },
                                options: {
                                    type: 'select',
                                    expected: 'singleChoice',
                                    items: [
                                        {
                                            index: "5.2.1.1",
                                            selected: false,
                                            icon: 'Real-Estate Insurance Protection real-estate-insurance-dollar-hand',
                                            name: 'yes',
                                            label: {
                                                young: 'Ja',
                                                personal: 'Ja',
                                                formal: 'Ja'
                                            },
                                            points: {
                                                m: 3,
                                                v: 10,
                                                w: 3,
                                                y: 20,
                                                aa: 3,
                                                af: 10,
                                                aj: 30,
                                                ak: 30,
                                                am: 5,
                                                an: 20
                                            }
                                        },
                                        {
                                            index: "5.2.1.2",
                                            selected: false,
                                            icon: 'Real-Estate - Favorites - real-estate-favorite-hold-house',
                                            name: 'no',
                                            label: {
                                                young: 'Nein',
                                                personal: 'Nein',
                                                formal: 'Nein'
                                            },
                                            points: {
                                                m: 3,
                                                w: 3,
                                                y: 20,
                                                aa: 3,
                                                af: 5,
                                                am: 5
                                            }
                                        }
                                    ]
                                },
                                prevIndexString: "5",
                                currIndexString: "5.2.1",
                                nextIndexString: "6"
                            }
                        ]
                    },
                    {
                        index: "5.3",
                        selected: false,
                        icon: 'Building-Construction Houses house-modern',
                        name: 'own-house',
                        label: {
                            young: 'eigenes Haus',
                            personal: 'eigenes Haus',
                            formal: 'eigenes Haus'
                        },
                        points: {
                            m: 3,
                            v: 10,
                            w: 3,
                            y: 20,
                            z: 50,
                            aa: 3,
                            af: 10,
                            am: 5
                        },
                        childQuestions: [
                            {
                                index: "5.3.1",
                                icon: '',
                                name: '',
                                question: {
                                    text: {
                                        young: 'Ist das Haus finanziert?',
                                        personal: 'Ist das Haus finanziert?',
                                        formal: 'Ist das Haus finanziert?',
                                    }
                                },
                                options: {
                                    type: 'select',
                                    expected: 'singleChoice',
                                    items: [
                                        {
                                            index: "5.3.1.1",
                                            selected: false,
                                            icon: 'Real-Estate Insurance Protection real-estate-insurance-dollar-hand',
                                            name: 'yes',
                                            label: {
                                                young: 'Ja',
                                                personal: 'Ja',
                                                formal: 'Ja'
                                            },
                                            points: {
                                                v: 10,
                                                w: 3,
                                                af: 10,
                                                aj: 30,
                                                ak: 30,
                                                am: 5,
                                                an: 20
                                            }
                                        },
                                        {
                                            index: "5.3.1.2",
                                            selected: false,
                                            icon: 'Real-Estate - Favorites - real-estate-favorite-hold-house',
                                            name: 'no',
                                            label: {
                                                young: 'Nein',
                                                personal: 'Nein',
                                                formal: 'Nein'
                                            },
                                            points: {
                                                w: 3,
                                                af: 5,
                                                am: 5
                                            }
                                        }
                                    ]
                                },
                                prevIndexString: "5",
                                currIndexString: "5.3.1",
                                nextIndexString: "5.3.2"
                            },
                            {
                                index: "5.3.2",
                                selected: false,
                                icon: '',
                                name: 'warm',
                                question: {
                                    text: {
                                        young: 'Wie sieht Deine Energieversorgung aus?',
                                        personal: 'Wie sieht Deine Energieversorgung aus?',
                                        formal: 'Wie sieht Deine Energieversorgung aus?',
                                    }
                                },
                                options: {
                                    type: 'select',
                                    expected: 'multipleChoice',
                                    items: [
                                        {
                                            index: "5.3.2.1",
                                            selected: false,
                                            icon: 'Ecology Nuclear-Fossil-Energy fossil-energy-gas-latern',
                                            name: 'gas',
                                            label: {
                                                young: 'Gas',
                                                personal: 'Gas',
                                                formal: 'Gas'
                                            },
                                            points: {
                                                af: 5,
                                                am: 2
                                            }
                                        },
                                        {
                                            index: "5.3.2.2",
                                            selected: false,
                                            icon: 'Ecology Nuclear-Fossil-Energy fossil-energy-barrel',
                                            name: 'oil',
                                            label: {
                                                young: 'Öl',
                                                personal: 'Öl',
                                                formal: 'Öl'
                                            },
                                            points: {
                                                ad: 30,
                                                af: 5,
                                                am: 2
                                            }
                                        },
                                        {
                                            index: "5.3.2.3",
                                            selected: false,
                                            icon: 'Ecology Renewable-Energy renewable-energy-solar-panel',
                                            name: 'solar',
                                            label: {
                                                young: 'Solar',
                                                personal: 'Solar',
                                                formal: 'Solar'
                                            },
                                            points: {
                                                z: 5,
                                                aa: 3,
                                                af: 5,
                                                am: 2
                                            }
                                        },
                                        {
                                            index: "5.3.2.4",
                                            selected: false,
                                            icon: 'Ecology Renewable-Energy renewable-energy-solar-power',
                                            name: 'photovoltaic',
                                            label: {
                                                young: 'Photovoltaik',
                                                personal: 'Photovoltaik',
                                                formal: 'Photovoltaik'
                                            },
                                            points: {
                                                ae: 30,
                                                af: 5,
                                                am: 2
                                            }
                                        },
                                        {
                                            index: "5.3.2.5",
                                            selected: false,
                                            icon: 'Ecology - Renewable-Energy - renewable-energy-water-dam-1',
                                            name: 'pump',
                                            label: {
                                                young: 'Wärmepumpe',
                                                personal: 'Wärmepumpe',
                                                formal: 'Wärmepumpe'
                                            },
                                            points: {
                                                z: 5,
                                                af: 5,
                                                am: 2
                                            }
                                        }
                                    ]
                                },
                                prevIndexString: "5.3.1 ",
                                currIndexString: "5.3.2",
                                nextIndexString: "6"
                            }
                        ]
                    },
                    {
                        index: "5.4",
                        selected: false,
                        icon: 'Building-Construction Houses house-user',
                        name: 'parents-partner',
                        label: {
                            young: 'bei den Eltern / Partner',
                            personal: 'bei den Eltern / Partner',
                            formal: 'bei den Eltern / Partner'
                        },
                        points: {
                            m: 1,
                            af: 5
                        }
                    },
                    {
                        index: "5.5",
                        selected: false,
                        icon: 'Building-Construction Buildings building-2',
                        name: 'shared-flat',
                        label: {
                            young: 'WG / Studentenwohnung',
                            personal: 'WG / Studentenwohnung',
                            formal: 'WG / Studentenwohnung'
                        },
                        points: {
                            m: 1,
                            w: 3,
                            y: 20,
                            af: 5
                        }
                    }
                ]
            },
            prevIndexString: "4",
            currIndexString: "5",
            nextIndexString: "6"
        },
        {
            index: "6",
            icon: '',
            name: 'possessions',
            question: {
                text: {
                    young: 'Was besitzt Du?',
                    personal: 'Was besitzt Du?',
                    formal: 'Was besitzt Du?'
                }
            },
            options: {
                type: 'select',
                expected: 'multipleChoice',
                items: [
                    {
                        index: "6.1",
                        selected: false,
                        icon: 'Motorrad-Auto',
                        name: 'car-bike',
                        label: {
                            young: 'Auto/Motorrad',
                            personal: 'Auto/Motorrad',
                            formal: 'Auto/Motorrad'
                        },
                        points: {
                            f: 60,
                            m: 5,
                            v: 5
                        }
                    },
                    {
                        index: "6.2",
                        selected: false,
                        icon: 'Transportation Scooters Bikes scooter-1',
                        name: 'bike-div',
                        label: {
                            young: 'Moped/Roller/E-Bike',
                            personal: 'Moped/Roller/E-Bike',
                            formal: 'Moped/Roller/E-Bike'
                        },
                        points: {
                            f: 60,
                            m: 5,
                            v: 5
                        }
                    },
                    {
                        index: "6.3",
                        selected: false,
                        icon: 'FahrradPedelec',
                        name: 'bicycle',
                        label: {
                            young: 'Fahrrad/Pedelec',
                            personal: 'Fahrrad/Pedelec',
                            formal: 'Fahrrad/Pedelec'
                        },
                        points: {
                            m: 5,
                            v: 5,
                            w: 1,
                            y: 10,
                            ag: 30
                        }
                    },
                    {
                        index: "6.4",
                        selected: false,
                        icon: 'Transportation Segway segway-2',
                        name: 'scooter',
                        label: {
                            young: 'E-Scooter',
                            personal: 'E-Scooter',
                            formal: 'E-Scooter'
                        },
                        points: {
                            f: 60,
                            m: 2,
                            v: 5
                        }
                    },
                    {
                        index: "6.5",
                        selected: false,
                        icon: 'Transportation - Sea Transportation - sea-transport-wheel-boat',
                        name: 'boat',
                        label: {
                            young: 'Boot',
                            personal: 'Boot',
                            formal: 'Boot'
                        },
                        points: {
                            g: 50,
                            m: 1,
                            v: 5
                        }
                    },
                    {
                        index: "6.6",
                        selected: false,
                        icon: 'Technology Drones drone-camera',
                        name: 'drone',
                        label: {
                            young: 'Drohne',
                            personal: 'Drohne',
                            formal: 'Drohne'
                        },
                        points: {
                            k: 30,
                            m: 1,
                            y: 5
                        }
                    },
                    {
                        index: "6.7",
                        selected: false,
                        icon: 'Pets-Animals Dogs dog-poodle',
                        name: 'dog',
                        label: {
                            young: 'Hund',
                            personal: 'Hund',
                            formal: 'Hund'
                        },
                        points: {
                            h: 60,
                            l: 20,
                            m: 1
                        }
                    },
                    {
                        index: "6.8",
                        selected: false,
                        icon: 'Outdoors-Recreation Outdoor-Parks outdoors-horse',
                        name: 'horse',
                        label: {
                            young: 'Pferd',
                            personal: 'Pferd',
                            formal: 'Pferd'
                        },
                        points: {
                            i: 50,
                            l: 20,
                            m: 1
                        }
                    },
                    {
                        index: "6.9",
                        selected: false,
                        icon: 'Entertainment-Event-Hobbies Museum-Exhibitions museum-painting',
                        name: 'collections',
                        label: {
                            young: 'hochwertige Sammlungen',
                            personal: 'hochwertige Sammlungen',
                            formal: 'hochwertige Sammlungen'
                        },
                        points: {
                            y: 10,
                            ah: 30
                        }
                    },
                    {
                        index: "6.10",
                        selected: false,
                        icon: 'Building-Construction Construction construction-house-1',
                        name: 'building-extension',
                        label: {
                            young: 'geplanter Rohbau / Neubau / Anbau',
                            personal: 'geplanter Rohbau / Neubau / Anbau',
                            formal: 'geplanter Rohbau / Neubau / Anbau'
                        },
                        points: {
                            m: 7,
                            v: 5,
                            x: 20,
                            z: 10,
                            af: 10,
                            aj: 10,
                            ak: 10,
                            am: 5
                        }
                    },
                    {
                        index: "6.11",
                        selected: false,
                        icon: 'Building-Construction Conception Projects project-blueprint-buildings',
                        name: 'vacant-property',
                        label: {
                            young: 'unbebautes Grundstück',
                            personal: 'unbebautes Grundstück',
                            formal: 'unbebautes Grundstück'
                        },
                        points: {
                            m: 2,
                            ac: 30,
                            af: 10,
                            am: 5
                        }
                    },
                    {
                        index: "6.12",
                        selected: false,
                        icon: 'Real-Estate - Actions-Buildings - real-estate-action-building-dollar',
                        name: 'landlord',
                        label: {
                            young: 'Haus / Wohnung als Vermieter',
                            personal: 'Haus / Wohnung als Vermieter',
                            formal: 'Haus / Wohnung als Vermieter'
                        },
                        points: {
                            m: 2,
                            z: 10,
                            ab: 20,
                            ac: 30,
                            af: 10,
                            aj: 10,
                            ak: 10,
                            am: 5
                        }
                    }
                    ]
            },
            prevIndexString: "5",
            currIndexString: "6",
            nextIndexString: "7"
        },
        {
            index: "7",
            icon: '',
            name: 'saving',
            question: {
                text: {
                    young: 'Wofür sparst Du?',
                    personal: 'Wofür sparst Du?',
                    formal: 'Wofür sparst Du?'
                }
            },
            options: {
                type: 'select',
                expected: 'multipleChoice',
                items: [
                    {
                        index: "7.1",
                        selected: false,
                        icon: 'Motorrad-Auto',
                        name: 'car-bike',
                        label: {
                            young: 'Auto/Motorrad',
                            personal: 'Auto/Motorrad',
                            formal: 'Auto/Motorrad'
                        },
                        points: {
                            am: 5,
                            an: 10
                        }
                    },
                    {
                        index: "7.2",
                        selected: false,
                        icon: 'Transportation Scooters Bikes scooter-3',
                        name: 'bike-div',
                        label: {
                            young: 'Moped/Roller/E-Scooter',
                            personal: 'Moped/Roller/E-Scooter',
                            formal: 'Moped/Roller/E-Scooter'
                        },
                        points: {
                            am: 5,
                            an: 5
                        }
                    },
                    {
                        index: "7.3",
                        selected: false,
                        icon: 'FahrradPedelec',
                        name: 'bicycle',
                        label: {
                            young: 'Fahrrad/E-Bike',
                            personal: 'Fahrrad/E-Bike',
                            formal: 'Fahrrad/E-Bike'
                        },
                        points: {
                            am: 2
                        }
                    },
                    {
                        index: "7.4",
                        selected: false,
                        icon: 'Entertainment-Event-Hobbies - Party - party-music',
                        name: 'hobbies',
                        label: {
                            young: 'Hobbies',
                            personal: 'Hobbies',
                            formal: 'Hobbies'
                        },
                        points: {
                            am: 2
                        }
                    },
                    {
                        index: "7.5",
                        selected: false,
                        icon: 'Family-Babies-Kids Family family-children',
                        name: 'family',
                        label: {
                            young: 'Familie',
                            personal: 'Familie',
                            formal: 'Familie'
                        },
                        points: {
                            am: 2
                        }
                    },
                    {
                        index: "7.6",
                        selected: false,
                        icon: 'Pets-Animals - Animals-Prints - animal-print',
                        name: 'pets',
                        label: {
                            young: 'Tier/Haustier',
                            personal: 'Tier/Haustier',
                            formal: 'Tier/Haustier'
                        },
                        points: {
                            am: 2
                        }
                    },
                    {
                        index: "7.7",
                        selected: false,
                        icon: 'Building-Construction Houses house-modern_wannahave',
                        name: 'house',
                        label: {
                            young: 'Haus',
                            personal: 'Haus',
                            formal: 'Haus'
                        },
                        points: {
                            af: 10,
                            am: 5
                        }
                    },
                    {
                        index: "7.8",
                        selected: false,
                        icon: 'Science Astronomy astronomy-telescope',
                        name: 'future',
                        label: {
                            young: 'Alter/Zukunft',
                            personal: 'Alter/Zukunft',
                            formal: 'Alter/Zukunft'
                        },
                        points: {
                            ai: 20,
                            am: 5
                        }
                    },
                    {
                        index: "7.9",
                        selected: false,
                        icon: 'Transportation Cars car-voyage',
                        name: 'holidays',
                        label: {
                            young: 'Urlaub',
                            personal: 'Urlaub',
                            formal: 'Urlaub'
                        },
                        points: {
                            n: 15,
                            am: 2
                        }
                    },
                    {
                        index: "7.10",
                        selected: false,
                        icon: 'Money-Payments-Finance - Crypto-Currencies - crypto-currency-bitcoin-stack-coins',
                        name: 'misc',
                        label: {
                            young: 'Sonstiges',
                            personal: 'Sonstiges',
                            formal: 'Sonstiges'
                        },
                        points: {
                            am: 2
                        }
                    }
                ]
            },
            prevIndexString: "6",
            currIndexString: "7",
            nextIndexString: "8"
        },
        {
            index: "8",
            icon: '',
            name: '',
            question: {
                text: {
                    young: 'Welche Hobbies hast Du?',
                    personal: 'Welche Hobbies hast Du?',
                    formal: 'Welche Hobbies hast Du?'
                }
            },
            options: {
                type: 'select',
                expected: 'multipleChoice',
                items: [
                    {
                        index: "8.1",
                        selected: false,
                        icon: 'Transportation Cars car-voyage',
                        name: 'travel',
                        label: {
                            young: 'Reisen',
                            personal: 'Reisen',
                            formal: 'Reisen'
                        },
                        points: {
                            m: 1,
                            n: 15,
                            w: 1,
                            am: 2
                        }
                    },
                    {
                        index: "8.2",
                        selected: false,
                        icon: 'Sports Gymnastics gymnastics-acrobatic-1',
                        name: 'sports',
                        label: {
                            young: 'Sport',
                            personal: 'Sport',
                            formal: 'Sport'
                        },
                        childQuestions: [
                            {
                                index: "8.2.1",
                                icon: '',
                                name: '',
                                question: {
                                    text: {
                                        young: 'Welchen Sport machst Du?',
                                        personal: 'Welchen Sport machst Du?',
                                        formal: 'Welchen Sport machst Du?',
                                    }
                                },
                                options: {
                                    type: 'select',
                                    expected: 'multipleChoice',
                                    items: [
                                        {
                                            index: "8.2.1.1",
                                            selected: false,
                                            icon: 'Sports Tennis-Badminton tennis-forehand',
                                            name: 'ball',
                                            label: {
                                                young: 'Ballsport',
                                                personal: 'Ballsport',
                                                formal: 'Ballsport'
                                            },
                                            points: {
                                                o: 5,
                                                p: 1,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 3,
                                                aj: 5
                                            }
                                        },
                                        {
                                            index: "8.2.1.2",
                                            selected: false,
                                            icon: 'Sports Biking biking-person',
                                            name: 'bike',
                                            label: {
                                                young: 'Radsport',
                                                personal: 'Radsport',
                                                formal: 'Radsport'
                                            },
                                            points: {
                                                m: 1,
                                                o: 5,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 3,
                                                y: 5,
                                                ag: 15,
                                                aj: 5
                                            }
                                        },
                                        {
                                            index: "8.2.1.3",
                                            selected: false,
                                            icon: 'Sports Fitness fitness-weightlift',
                                            name: 'fitness',
                                            label: {
                                                young: 'Fitness/Studio',
                                                personal: 'Fitness/Studio',
                                                formal: 'Fitness/Studio'
                                            },
                                            points: {
                                                s: 5,
                                                v: 5,
                                                w: 3
                                            }
                                        },
                                        {
                                            index: "8.2.1.4",
                                            selected: false,
                                            icon: 'Sports Martial-Arts martial-arts-karate',
                                            name: 'martial',
                                            label: {
                                                young: 'Kampfsport',
                                                personal: 'Kampfsport',
                                                formal: 'Kampfsport'
                                            },
                                            points: {
                                                m: 1,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 3,
                                                aj: 5,
                                                ak: 5
                                            }
                                        },
                                        {
                                            index: "8.2.1.5",
                                            selected: false,
                                            icon: 'Sports Skiing ski-jumping',
                                            name: 'winter',
                                            label: {
                                                young: 'Wintersport',
                                                personal: 'Wintersport',
                                                formal: 'Wintersport'
                                            },
                                            points: {
                                                n: 3,
                                                o: 5,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 3,
                                                y: 5,
                                                aj: 5
                                            }
                                        },
                                        {
                                            index: "8.2.1.6",
                                            selected: false,
                                            icon: 'Outdoors-Recreation Diving diving-diver',
                                            name: 'diving',
                                            label: {
                                                young: 'Tauchen',
                                                personal: 'Tauchen',
                                                formal: 'Tauchen'
                                            },
                                            points: {
                                                n: 3,
                                                o: 5,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 1,
                                                y: 5,
                                                aj: 5,
                                                ak: 5
                                            }
                                        },
                                        {
                                            index: "8.2.1.7",
                                            selected: false,
                                            icon: 'Sports Biking biking-mountain',
                                            name: 'extreme',
                                            label: {
                                                young: 'Extremsport',
                                                personal: 'Extremsport',
                                                formal: 'Extremsport'
                                            },
                                            points: {
                                                n: 3,
                                                o: 5,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 1,
                                                y: 5,
                                                aj: 5,
                                                ak: 5
                                            }
                                        },
                                        {
                                            index: "8.2.1.8",
                                            selected: false,
                                            icon: 'Outdoors-Recreation Nautical-Sports nautic-sports-sailing-person',
                                            name: 'water',
                                            label: {
                                                young: 'Wassersport',
                                                personal: 'Wassersport',
                                                formal: 'Wassersport'
                                            },
                                            points: {
                                                n: 3,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 1
                                            }
                                        },
                                        {
                                            index: "8.2.1.9",
                                            selected: false,
                                            icon: 'Outdoors-Recreation Outdoor-Parks outdoors-horse',
                                            name: 'riding',
                                            label: {
                                                young: 'Reiten',
                                                personal: 'Reiten',
                                                formal: 'Reiten'
                                            },
                                            points: {
                                                o: 5,
                                                s: 10,
                                                t: 1,
                                                v: 5,
                                                w: 1
                                            }
                                        },
                                        {
                                            index: "8.2.1.10",
                                            selected: false,
                                            icon: 'Sports Dancing dancing-ballet',
                                            name: 'misc',
                                            label: {
                                                young: 'Sonstiges',
                                                personal: 'Sonstiges',
                                                formal: 'Sonstiges'
                                            },
                                            points: {
                                                o: 5,
                                                s: 5,
                                                t: 1,
                                                v: 5,
                                                w: 1
                                            }
                                        }
                                    ]
                                },
                                prevIndexString: "8",
                                currIndexString: "8.2.1",
                                nextIndexString: "9"
                            }
                        ]
                    },
                    {
                        index: "8.3",
                        selected: false,
                        icon: 'Social-Medias-Rewards-Rating - Love-It - love-it-ribbon-2',
                        name: 'honor',
                        label: {
                            young: 'Ehrenamt',
                            personal: 'Ehrenamt',
                            formal: 'Ehrenamt'
                        },
                        points: {
                            m: 1,
                            w: 3
                        }
                    },
                    {
                        index: "8.4",
                        selected: false,
                        icon: 'Avatars Natural-Men-Vintage vintage-man-1',
                        name: 'hunting',
                        label: {
                            young: 'Jagd',
                            personal: 'Jagd',
                            formal: 'Jagd'
                        },
                        points: {
                            j: 50,
                            m: 1,
                            v: 5,
                            y: 5,
                            aj: 5,
                            ak: 5
                        }
                    },
                    {
                        index: "8.5",
                        selected: false,
                        icon: 'Science Space-Exploration space-astronaut',
                        name: 'misc',
                        label: {
                            young: 'Sonstiges',
                            personal: 'Sonstiges',
                            formal: 'Sonstiges'
                        },
                        points: {
                        }
                    }
                    ]
            },
            prevIndexString: "7",
            currIndexString: "8",
            nextIndexString: "8.2.1/9"
        },
        {
            index: "9",
            icon: '',
            name: 'work',
            question: {
                text: {
                    young: 'Arbeitest Du?',
                    personal: 'Arbeitest Du?',
                    formal: 'Arbeitest Du?'
                }
            },
            options: {
                type: 'select',
                expected: 'singleChoice',
                items: [
                    {
                        index: "9.1",
                        selected: false,
                        icon: 'user-cash-scale',
                        name: 'yes',
                        label: {
                            young: 'Ja',
                            personal: 'Ja',
                            formal: 'Ja'
                        },
                        childQuestions: [
                            {
                                index: "9.1.1",
                                icon: '',
                                name: '',
                                question: {
                                    text: {
                                        young: 'Was machst Du?',
                                        personal: 'Was machst Du?',
                                        formal: 'Was machst Du?',
                                    }
                                },
                                options: {
                                    type: 'select',
                                    expected: 'singleChoice',
                                    items: [
                                        {
                                            index: "9.1.1.1",
                                            selected: false,
                                            icon: 'user-cash-scale',
                                            name: 'employee',
                                            label: {
                                                young: 'Arbeitnehmer',
                                                personal: 'Arbeitnehmer',
                                                formal: 'Arbeitnehmer'
                                            },
                                            points: {
                                                m: 10,
                                                o: 5,
                                                s: 20,
                                                v: 10,
                                                w: 1,
                                                ai: 10,
                                                aj: 10,
                                                al: 5,
                                                am: 10
                                            }
                                        },
                                        {
                                            index: "9.1.1.2",
                                            selected: false,
                                            icon: 'Work-Office-Companies - Human-Resources - human-resources-employee-stress',
                                            name: 'selfemployed',
                                            label: {
                                                young: 'Selbstständig/Freiberuflich',
                                                personal: 'Selbstständig/Freiberuflich',
                                                formal: 'Selbstständig/Freiberuflich'
                                            },
                                            points: {
                                                m: 20,
                                                o: 5,
                                                s: 30,
                                                u: 30,
                                                v: 25,
                                                w: 1,
                                                ai: 20,
                                                aj: 20,
                                                ak: 5,
                                                al: 5,
                                                am: 15
                                            }
                                        },
                                        {
                                            index: "9.1.1.3",
                                            selected: false,
                                            icon: 'Avatars - Geometric-Men-People - people-man-7',
                                            name: 'azubi',
                                            label: {
                                                young: 'Azubi',
                                                personal: 'Azubi',
                                                formal: 'Azubi'
                                            },
                                            points: {
                                                m: 3,
                                                o: 1,
                                                s: 10,
                                                v: 10,
                                                w: 1,
                                                ai: 5,
                                                aj: 10,
                                                al: 5,
                                                am: 5
                                            }
                                        }
                                    ]
                                },
                                prevIndexString: "9",
                                currIndexString: "9.1.1",
                                nextIndexString: "10"
                            }
                        ]
                    },
                    {
                        index: "9.2",
                        selected: false,
                        icon: 'Weather - Weather - weather-sun',
                        name: 'no',
                        label: {
                            young: 'Nein',
                            personal: 'Nein',
                            formal: 'Nein'
                        },
                        childQuestions: [
                            {
                                index: "9.2.1",
                                icon: '',
                                name: '',
                                question: {
                                    text: {
                                        young: 'Was machst Du dann so?',
                                        personal: 'Was machst Du dann so?',
                                        formal: 'Was machst Du dann so?',
                                    }
                                },
                                options: {
                                    type: 'select',
                                    expected: 'singleChoice',
                                    items: [
                                        {
                                            index: "9.2.1.1",
                                            selected: false,
                                            icon: 'Avatars Natural-Women-People people-woman-graduate',
                                            name: 'student',
                                            label: {
                                                young: 'Schüler/Student',
                                                personal: 'Schüler/Student',
                                                formal: 'Schüler/Student'
                                            },
                                            points: {
                                                s: -100,
                                                v: 10,
                                                aj: 10,
                                                al: 5,
                                            }
                                        },
                                        {
                                            index: "9.2.1.2",
                                            selected: false,
                                            icon: 'Users - Geometric-Full-Body-Single-User-Actions-Man - single-man-actions-home',
                                            name: 'housekeeping',
                                            label: {
                                                young: 'Hausfrau/mann',
                                                personal: 'Hausfrau/mann',
                                                formal: 'Hausfrau/mann'
                                            },
                                            points: {
                                                o: 1,
                                                v: 20,
                                                w: 1,
                                                ai: 10,
                                                ak: 5,
                                                al: 5
                                            }
                                        },
                                        {
                                            index: "9.2.1.3",
                                            selected: false,
                                            icon: 'Avatars Natural-Men-Old-People old-people-man-3',
                                            name: 'oldie',
                                            label: {
                                                young: 'Rentner',
                                                personal: 'Rentner',
                                                formal: 'Rentner'
                                            },
                                            points: {
                                                m: 10,
                                                n: 30,
                                                o: 10,
                                                s: -100,
                                                v: 20,
                                                w: 1,
                                                af: -100,
                                                aj: -100,
                                                ak: 5,
                                                al: 15
                                            }
                                        },
                                        {
                                            index: "9.2.1.4",
                                            selected: false,
                                            icon: 'Weather - Weather - weather-sun',
                                            name: 'nothing',
                                            label: {
                                                young: 'ohne berufliche Tätigkeit',
                                                personal: 'ohne berufliche Tätigkeit',
                                                formal: 'ohne berufliche Tätigkeit'
                                            },
                                            points: {
                                                w: 1,
                                                ai: 5
                                            }
                                        }
                                    ]
                                },
                                prevIndexString: "9",
                                currIndexString: "9.2.1",
                                nextIndexString: "10"
                            }
                        ],
                        points: {
                            mobility: 0,
                            liability: 30,
                            legal: 2,
                            health: 1,
                            things: 2,
                            buildings: 0,
                            pension: 1,
                            income: 6,
                            capital: 1
                        }
                    }
                ]
            },
            prevIndexString: "8",
            currIndexString: "9",
            nextIndexString: "10"
        },
        {
            index: "10",
            icon: '',
            name: 'healthcosts',
            question: {
                text: {
                    young: 'Wer zahlt Deine Arztkosten?',
                    personal: 'Wer zahlt Deine Arztkosten?',
                    formal: 'Wer zahlt Deine Arztkosten?'
                }
            },
            options: {
                type: 'select',
                expected: 'singleChoice',
                items: [
                    {
                        index: "10.1",
                        selected: false,
                        icon: 'Health-Beauty - Insurance-Protection - insurance-card',
                        name: 'gkv',
                        label: {
                            young: 'Gesetzliche Krankenkasse',
                            personal: 'Gesetzliche Krankenkasse',
                            formal: 'Gesetzliche Krankenkasse'
                        },
                        points: {
                            o: 5,
                            s: 5,
                            ai: 10,
                            aj: 10
                        }
                    },
                    {
                        index: "10.2",
                        selected: false,
                        icon: 'Money-Payments-Finance Finance Savings saving-bank',
                        name: 'pkv',
                        label: {
                            young: 'Private Krankenversicherung',
                            personal: 'Private Krankenversicherung',
                            formal: 'Private Krankenversicherung'
                        },
                        points: {
                            o: 5,
                            q: 1,
                            r: 1,
                            s: 5,
                            t: 1,
                            u: 50,
                            ai: 20,
                            aj: 30
                        }
                    },
                    {
                        index: "10.3",
                        selected: false,
                        icon: 'Wayfinding Information-Desk information-desk-question-help',
                        name: 'wtf',
                        label: {
                            young: 'Keine Ahnung',
                            personal: 'Keine Ahnung',
                            formal: 'Keine Ahnung'
                        },
                        points: {
                            s: 5,
                            ai: 10,
                            aj: 10
                        }
                    }
                ]
            },
            prevIndexString: "9",
            currIndexString: "10",
            nextIndexString: "11"
        },
        {
            index: "11",
            icon: '',
            name: '',
            question: {
                text: {
                    young: 'Wie hoch ist Dein Monatsbrutto?',
                    personal: 'Wie hoch ist Dein Monatsbrutto?',
                    formal: 'Wie hoch ist Dein Monatsbrutto?'
                }
            },
            options: {
                type: 'select',
                expected: 'singleChoice',
                items: [
                    {
                        index: "11.1",
                        selected: false,
                        icon: 'Money-Payments-Finance - Finance-Savings - saving-money-egg',
                        name: 'nope',
                        label: {
                            young: 'Ich habe keins',
                            personal: 'Ich habe keins',
                            formal: 'Ich habe keins'
                        },
                        points: {
                        }
                    },
                    {
                        index: "11.2",
                        selected: false,
                        icon: 'Money-Payments-Finance Money accounting-coins-stack',
                        name: 's',
                        label: {
                            young: 'bis 2.000 EUR',
                            personal: 'bis 2.000 EUR',
                            formal: 'bis 2.000 EUR'
                        },
                        points: {
                            s: 5,
                            ai: 10,
                            aj: 10
                        }
                    },
                    {
                        index: "11.3",
                        selected: false,
                        icon: 'Money-Payments-Finance Money accounting-coins-bill',
                        name: 'm',
                        label: {
                            young: 'bis 3.000 EUR',
                            personal: 'bis 3.000 EUR',
                            formal: 'bis 3.000 EUR'
                        },
                        points: {
                            s: 10,
                            ai: 15,
                            aj: 15
                        }
                    },
                    {
                        index: "11.4",
                        selected: false,
                        icon: 'Money-Payments-Finance Money accounting-bills-1',
                        name: 'l',
                        label: {
                            young: 'bis 5.000 EUR',
                            personal: 'bis 5.000 EUR',
                            formal: 'bis 5.000 EUR'
                        },
                        points: {
                            o: 10,
                            s: 15,
                            v: 10,
                            ai: 20,
                            aj: 20
                        }
                    },
                    {
                        index: "11.5",
                        selected: false,
                        icon: 'Money-Payments-Finance - Accounting-Billing - accounting-calculator-2',
                        name: 'xl',
                        label: {
                            young: 'mehr als hier steht',
                            personal: 'mehr als hier steht',
                            formal: 'mehr als hier steht'
                        },
                        points: {
                            o: 20,
                            s: 20,
                            u: 30,
                            v: 10,
                            ai: 30,
                            aj: 30
                        }
                    }
                ]
            },
            prevIndexString: "10",
            currIndexString: "11",
            nextIndexString: "12"
        },
        {
            index: "12",
            icon: '',
            name: '',
            question: {
                text: {
                    young: 'Welche dieser Gesundheitsthemen sind Dir wichtig?',
                    personal: 'Welche dieser Gesundheitsthemen sind Dir wichtig?',
                    formal: 'Welche dieser Gesundheitsthemen sind Dir wichtig?'
                }
            },
            options: {
                type: 'select',
                expected: 'multipleChoice',
                items: [
                    {
                        index: "12.1",
                        selected: false,
                        icon: 'Health-Beauty Dentistry dentistry-tooth-search',
                        name: 'care',
                        label: {
                            young: 'Zahnvorsorge',
                            personal: 'Zahnvorsorge',
                            formal: 'Zahnvorsorge'
                        },
                        points: {
                            p: 20
                        }
                    },
                    {
                        index: "12.2",
                        selected: false,
                        icon: 'Health-Beauty Dentistry dentistry-tooth-exchange',
                        name: 'replace',
                        label: {
                            young: 'Zahnersatz',
                            personal: 'Zahnersatz',
                            formal: 'Zahnersatz'
                        },
                        points: {
                            p: 20
                        }
                    },
                    {
                        index: "12.3",
                        selected: false,
                        icon: 'Clothes-Footwear-Accessories - Glasses - glasses-sun-1',
                        name: 'glasses',
                        label: {
                            young: 'Brille',
                            personal: 'Brille',
                            formal: 'Brille'
                        },
                        points: {
                            r: 20
                        }
                    },
                    {
                        index: "12.4",
                        selected: false,
                        icon: 'Health-Beauty Hospital hospital-building-1',
                        name: 'hospital',
                        label: {
                            young: 'Krankenhausbehandlung',
                            personal: 'Krankenhausbehandlung',
                            formal: 'Krankenhausbehandlung'
                        },
                        points: {
                            t: 20
                        }
                    },
                    {
                        index: "12.5",
                        selected: false,
                        icon: 'Health-Beauty Hospital-Bedrooms hospital-bedroom-nurse',
                        name: 'care',
                        label: {
                            young: 'Pflegeabsicherung',
                            personal: 'Pflegeabsicherung',
                            formal: 'Pflegeabsicherung'
                        },
                        points: {
                            o: 20
                        }
                    },
                    {
                        index: "12.6",
                        selected: false,
                        icon: 'Health-Beauty Medical-Symbol medical-hospital-2',
                        name: 'alternative',
                        label: {
                            young: 'Alternative Heilmethoden',
                            personal: 'Alternative Heilmethoden',
                            formal: 'Alternative Heilmethoden'
                        },
                        points: {
                            q: 20
                        }
                    },
                    {
                        index: "12.7",
                        selected: false,
                        icon: 'saving-money-flower',
                        name: 'income',
                        label: {
                            young: 'Lohnfortzahlung',
                            personal: 'Lohnfortzahlung',
                            formal: 'Lohnfortzahlung'
                        },
                        points: {
                            s: 20
                        }
                    },
                    {
                        index: "12.8",
                        selected: false,
                        icon: 'Design - Design-Tools - design-tool-magic-wand-1',
                        name: 'income',
                        label: {
                            young: 'Nichts, ist mir egal.',
                            personal: 'Nichts, ist mir egal.',
                            formal: 'Nichts, ist mir egal.'
                        },
                        points: {
                        }
                    }
                ]
            },
            prevIndexString: "11",
            currIndexString: "12",
            nextIndexString: ""
        }
    ],
    in: [
        {
            index: 0,
            answer: ""
        },
        {
            index: 1,
            answer: ""
        },
        {
            index: 2,
            answer: ""
        },
        {
            index: 3,
            answer: {
                index: '',
                selection: ''
            }
        },
        {
            index: 4,
            answer: {
                index: '',
                selection: ''
            }
        },
        {
            index: 5,
            answer: {
                index: '',
                selection: ''
            }
        },
        {
            index: 6,
            answers: [
            ]
        },
        {
            index: 7,
            answers: []
        },
        {
            index: 8,
            answers: []
        },
        {
            index: 9,
            answers: []
        },
        {
            index: 10,
            answers: []
        }
    ],
    recommendations: [],
    icons4pdf: []
};


const mutations = {
    SET_ICONS4PDF: (state,icons4pdf) => {
        Vue.set(state,'icons4pdf',icons4pdf);
    },
    SET_USER_EMAIL: (state,value) => {
        state.user.email = value;
    },
    SET_ANSWER: (state,answerSet) => {
        for (var i = 0; i < state.in.length; i++) {
            if (state.in[i].index == answerSet.index) {
                state.in[i].answer = answerSet.text;
                if(answerSet.index == 1) {
                    state.user.name = answerSet.text;
                }
                return;
            }
        }
        // state.in.push({ 'index': answerSet.index, 'answer': answerSet.text });
        Vue.set(state.in,state.in.length,{ 'index': answerSet.index, 'answer': answerSet.text });
    },
    SET_RESPONSIVE_ICON_SOURCE: (state,iconInfo) => {
        if(iconInfo.index==5) {
            state.reactiveIcons.oneOne.src = iconInfo.src + '.svg';
        }
    },
    /**
     *
     * @param state
     * @param answerSet
     *      answerSet.index = Index der Frage, zu der diese Antwort gehört
     *      answerSet.selection.index = Index der gewählten Antwortoption
     *      answerSet.selection.label = Label der gewählten Antwortoption
     */
    SET_SINGLE_CHOICE_SELECTION: (state,answerSet) => {
        for (var i = 0; i < state.in.length; i++) {
            if (state.in[i].index == answerSet.index) {
                // state.in[i].answer = answerSet.selection;
                Vue.set(state.in[i],'answer',answerSet.selection);
                return;
            }
        }
        // state.in.push({ 'index': answerSet.index, 'answer': answerSet.selection });
        Vue.set(state.in,state.in.length,{ 'index': answerSet.index, 'answer': answerSet.selection });
    },
    /**
     *
     * @param state
     * @param answerSet
     *        answerSet.index = Index der Frage, zu der diese Antwort gehört
     *        answerSet.selection.indexes = Array mit Indizes der gewählten Antwortoptionen
     *        answerSet.selection.labels = Array mit den Labels der gewählten Antwortoptionen
     */
    SET_MULTIPLE_CHOICE_SELECTION: (state,answerSet) => {
        for (var i = 0; i < state.in.length; i++) {
            if (state.in[i].index == answerSet.index) {
                // Sonderlocke wg. 12.8 (Mischung aus Einzel- und Mehrfachantwort)
                if(answerSet.index=='12' && state.in[i].answers.length > 0 && state.in[i].answers[0].index=='12.8' && answerSet.selection.length > 1) {
                    for (let j = 0; j < answerSet.selection.length; j++) {
                        if (answerSet.selection[j].index != '12.8') {
                            let tmp = answerSet.selection[j];
                            answerSet.selection.length = 0;
                            answerSet.selection.push(tmp);
                            break;
                        }
                    }
                }
                else if(answerSet.index=='12' && answerSet.selection.length > 0 && answerSet.selection[answerSet.selection.length-1].index=='12.8') {
                    let tmp = answerSet.selection[answerSet.selection.length-1];
                    answerSet.selection.length = 0;
                    answerSet.selection.push(tmp);
                }
                Vue.set(state.in[i],'answers',answerSet.selection);
                return;
            }
        }
        Vue.set(state.in,state.in.length,{ 'index': answerSet.index,
            'answers': [answerSet.selection[0]]
        });
    },
    STORE_MULTIPLE_SELECTION: (state,answerSet) => {
        let target = state.in.filter( item => item.index == answerSet.index)[0].answers = answerSet.selection;
    },
    SET_RECOMMENDATIONS: (state,rec) => {
        state.recommendations.length = 0; // empty the array
        // state.recommendations = Object.assign([],rec);
        Vue.set(state,'recommendations',rec);
        // state.recommendations.push(rec);
        // Set default checked state for all recommendations
        for(let i=0; i < state.recommendations.length; i++) {
            // state.recommendations[i].checked = true;
            // state.recommendations[i].decision = '';
            Vue.set(state.recommendations[i],'checked',true);
            Vue.set(state.recommendations[i],'decision','');
        }
    },
    SET_PRODUCT_CHECKED: (state,answerSet) => {
        for(let i=0; i < state.recommendations.length; i++){
            if(state.recommendations[i].col == answerSet.col) {
                state.recommendations[i].checked = answerSet.state;
            }
        }
    },
    SET_PRODUCT_DECISION: (state,answerSet) => {
        for(let i=0; i < state.recommendations.length; i++){
            if(state.recommendations[i].col == answerSet.col) {
                state.recommendations[i].decision = answerSet.decision;
            }
        }
    }
};

const getters = {
    getTest: state => {
        return state.test;
    },
    getUser: state => {
        return state.user;
    },
    getUserEmail: state => {
        return state.user.email;
    },
    getUserName: state => {
        return state.user.name;
    },
    /* Getter für Fragen */
    getTotalNumberOfQuestions: state => {
        return state.out.length;
    },
    getQuestions: state => {
        return state.out;
    },
    getAnswer: state => index => {
        return state.in.filter(inItem => inItem.index == index)[0];
    },
    getQuestionHasAnswer: state => index => {
        let answers = state.in.filter(inItem => inItem.index == index);
        if(answers[0].answer.index!=undefined && answers[0].answer.index!=''){
            return true;
        }
        if(answers[0].answers.length>0){
            return true;
        }
        return false;
    },
    getAnswerInputText: state => index => {
        return state.in.filter(inItem => (inItem.index) == (index))[0].answer;
    },
    getSingleChoiceSelection: state => index => {
        let choice = state.in.filter(inItem => inItem.index == index);
        if(choice!=undefined && choice.length > 0) {
            return choice[0];
        }
        return false;
    },
    getSingleChoiceSelectionValue: state => index => {
        let choice = state.in.filter(inItem => inItem.index == index);
        if(choice!=undefined && choice.length > 0) {
            return choice[0].answer;
        }
        return false;
    },
    getMultipleChoiceSelection: state => index => {
        let choice = state.in.filter(inItem => inItem.index == index);
        if(choice!=undefined && choice.length > 0) {
            return choice[0];
        }
        return [];
    },
    getMultipleChoiceSelectionValue: state => index => {
        let choice = state.in.filter(inItem => inItem.index == index);
        if(choice!=undefined && choice.length > 0) {

            return choice[0].answers;
        }
        return [];
    },
    // z.B. '1' oder '2.1' oder '4.1.2'
    getQuestionByIndexString: state => indexString => {
        indexString += '';  // must be string
        let indexes = indexString.split('.');
        let currLevel = indexes.length;
        if(currLevel==1){
            if(indexes[0] < 1) { return false; }
            return state.out[indexes[0]-1];
        }
        else if(currLevel==2){
            if(indexes[0] < 1 || indexes[1] < 1) { return false; }
            return state.out[indexes[0]-1].childQuestions[indexes[1]-1];
        }
        else if(currLevel==3){
            if(indexes[0] < 1 || indexes[1] < 1 || indexes[2] < 1) { return false; }
            // return state.out[indexes[0]-1].childQuestions[indexes[1]-1].childQuestions[indexes[2]-1];
            return state.out[indexes[0]-1].options.items[indexes[1]-1].childQuestions[indexes[2]-1];
        }
    },
    /**
     * Get all the topics sorted by numeric property sortOrder
     * @param state
     * @returns {this}
     */
    getTopics: (state) => {
        let t = state.topics.sort((a,b) => (a.sortOrder - b.sortOrder));
        return t;
    },
    /**
     * Getter for recommendations, grouped by topic
     * @param state
     * @returns {Function}
     */
    getRecommendedProductsByTopic: (state) => topic => {
        topic += '';
        let p = state.recommendations.filter((rec) => (rec.topic == topic));
        return p;
    },

    getRecommendedProductsWithPointsByTopic: (state) => topic => {
        topic += '';
        let p = state.recommendations.filter((rec) => (rec.topic == topic && rec.points > 0));
        return p;
    },

    /* Getter for scoring */
    /**
     * Ermittle für jedes Produkt die Punktzahl anhand der Antworten
     * und liefere die sortierte Liste der Produkte zurück.
     * @param state
     */
    getRecommendedProducts: (state ) => {
        if(state.in.length < 13) { return; }
        return state.recommendations;
    },
    getProductIsChecked: state => col => {
        let p = state.recommendations.filter(rec => rec.col == col);
        if(p == undefined) return false;
        return p[0].checked;
    },
    /**
     * Check if option is selected
     * Example: index = '8.2' => Check if option 2 is selected in question 8
     * Attention: This is NOT prepared for multilevel indexes like '8.2.1.1'
     * @param state
     * @returns {Function}
     */
    getOptionIsInAnswers: state => index => {
        if(index.length > 3) {
            console.log('ACHTUNG: getOptionIsInAnswers ist nicht für Indizes wie ' + index + ' ausgelegt!');
        }
        let tmp = index.split('.');
        let qIndex = tmp[0];
        let oIndex = tmp[1];
        let question = state.in.filter(rec => rec.index == qIndex)[0];
        if(question == undefined) return false;
        let option = question.answers.filter(opt => opt.index == index);
        return (option.length > 0);
    },

    /* Getters for the icon cloud sources */
    /* Section 1: Getters for icon places that are shared by multiple icons  */
    getHotspotIconSource: state => {
        // Maßgeblich sind die Antworten auf die Fragen 3 und 4 (Familienstatus und Anzahl Kinder)
        let src = "HotspotSingleZero"; // "Family-Babies-Kids Family family-children";
        let tmp = state.in.filter(inItem => inItem.index == 3);
        if(tmp == undefined || tmp[0].answer.index=='') { return src+'.svg'; }
        let famState = tmp[0].answer.index;  // z.B. 3.1 für Single und 3.2 für Ehe
        let tmptmp = state.in.filter(inItem => inItem.index == 4);
        if(tmptmp == undefined || tmptmp[0].answer.index=='') {
            // family state is answered, kidCount not
            src = 'HotspotSingleZero';
            if(famState=='3.2') { src = 'HotspotFamilyZero'; }
            return src+'.svg';
        }
        let kidCount = tmptmp[0].answer.index;  // z.B. 4.1 für keine Kinder, 4.3 für zwei Kinder
        switch(famState){
            case '3.1':
                switch(kidCount){
                    case '4.1':
                        src = 'HotspotSingleZero';
                        break;
                    case '4.2':
                        src = 'HotspotSingleOne';
                        break;
                    case '4.3':
                        src = 'HotspotSingleTwo';
                        break;
                    case '4.4':
                        src = 'HotspotSingleThree';
                        break;
                    default:
                        src = 'HotspotSingleZero';
                        break;
                }
                break;
            case '3.2':
                switch(kidCount) {
                    case '4.1':
                        src = 'HotspotFamilyZero';
                        break;
                    case '4.2':
                        src = 'HotspotFamilyOne';
                        break;
                    case '4.3':
                        src = 'HotspotFamilyTwo';
                        break;
                    case '4.4':
                        src = 'HotspotFamilyThree';
                        break;
                    default:
                        src = 'HotspotFamilyZero';
                        break;
                }
            break;
            default:
                src = 'Family-Babies-Kids Family family-children';
                break;
        }
        return src+'.svg';
    },
    getHouseIconSource: state => {
        // Maßgeblich ist die Antwort auf die Fragen 5 (Wie ist Deine Wohnsituation?)
        let src = 'Building-Construction Houses house-modern';
        let tmp = state.in.filter(inItem => inItem.index == 5);
        if(tmp == undefined || tmp[0].answer.index=='') { return src+'.svg'; }
        let houseState = tmp[0].answer.index;  // z.B. 5.1 für Miete
        let tmptmp = state.in.filter(inItem => inItem.index == 4);
        switch(houseState){
            case '5.1':
                src = 'Building-Construction - Buildings - buildings-1';
                break;
            case '5.2':
                src = 'Building-Construction Buildings building-1';
                break;
            case '5.3':
                src = 'Building-Construction Houses house-modern';
                break;
            case '5.4':
                src = 'Building-Construction Houses house-user';
                break;
            case '5.5':
                src = 'Building-Construction Buildings building-2';
                break;
            default:
                src = 'Building-Construction Houses house-modern';
                break;
        }
        return src+'.svg';
    },
    getEmploymentIconSource: state => {
        // Maßgeblich sind die Antworten auf die Fragen 9, 9.1.1 und 9.2.1 (Arbeitest Du? und die beiden Folgefragen)
        let src = "Weather - Weather - weather-sun"; // "Family-Babies-Kids Family family-children";
        let tmp = state.in.filter(inItem => inItem.index == '9');
        if(tmp == undefined || tmp.length==0 || tmp[0].answer == undefined || tmp[0].answer.index=='') { return src+'.svg'; }
        let workState = tmp[0].answer.index;  // z.B. 9.1 für ja und 9.2 für nein
        let yestmp = state.in.filter(inItem => inItem.index == '9.1.1');
        let notmp = state.in.filter(inItem => inItem.index == '9.2.1');
        if( (yestmp == undefined || yestmp[0]==undefined || yestmp.length==0 || yestmp[0].answer == undefined || yestmp[0].answer.index=='') && (notmp == undefined || notmp.length==0 || notmp[0]==undefined || notmp[0].answer == undefined || notmp[0].answer.index=='') ) {
            // employment state is still undefined - return default
            switch(workState){
                case '9.1':
                    return 'Avatars - Geometric-Women-Professions - professions-woman-doctor-1.svg';
                    break;
                case '9.2':
                    return 'Weather - Weather - weather-sun.svg';
                    break;
            }
            return src+'.svg';
        }
        switch(workState){
            case '9.1':
                if(yestmp[0]==undefined) { return src+'.svg'; }
                switch(yestmp[0].answer.index){
                    case '9.1.1.1': // AN
                        src = 'user-cash-scale';
                        break;
                    case '9.1.1.2': // Selbst.
                        src = 'Work-Office-Companies - Human-Resources - human-resources-employee-stress';
                        break;
                    case '9.1.1.3': // Azubi
                        src = 'Avatars - Geometric-Men-People - people-man-7';
                        break;
                    default:
                        src = 'Avatars - Geometric-Women-Professions - professions-woman-doctor-1';
                        break;
                }
                break;
            case '9.2':
                if(notmp[0]==undefined) { return src+'.svg'; }
                switch(notmp[0].answer.index) {
                    case '9.2.1.1': // Schüler
                        src = 'Avatars Natural-Women-People people-woman-graduate';
                        break;
                    case '9.2.1.2': // Hausfrau
                        src = 'Users - Geometric-Full-Body-Single-User-Actions-Man - single-man-actions-home';
                        break;
                    case '9.2.1.3': // Rentner
                        src = 'Avatars Natural-Men-Old-People old-people-man-3';
                        break;
                    case '9.2.1.4': // Ohne
                        src = 'Weather - Weather - weather-sun';
                        break;
                    default:
                        src = 'Weather - Weather - weather-sun';
                        break;
                }
                break;
            default:
                src = 'Weather - Weather - weather-sun';
                break;
        }
        return src+'.svg';
    },
    getIncomeIconSource: state => {
        // Maßgeblich ist die Antwort auf die Fragen 11 (Wie hoch ist dein Monatsbrutto?)
        let src = 'Money-Payments-Finance - Finance-Savings - saving-money-egg';
        let tmp = state.in.filter(inItem => inItem.index == 11);
        if(tmp == undefined  || tmp.length==0 || tmp[0].answer==undefined || tmp[0].answer.index==undefined ||tmp[0].answer.index=='') { return src+'.svg'; }
        let incomeState = tmp[0].answer.index;  // z.B. 5.1 für Miete
        switch(incomeState){
            case '11.1':
                src = 'Money-Payments-Finance - Finance-Savings - saving-money-egg';
                break;
            case '11.2':
                src = 'Money-Payments-Finance Money accounting-coins-stack';
                break;
            case '11.3':
                src = 'Money-Payments-Finance Money accounting-coins-bill';
                break;
            case '11.4':
                src = 'Money-Payments-Finance Money accounting-bills-1';
                break;
            case '11.5':
                src = 'Money-Payments-Finance - Accounting-Billing - accounting-calculator-2';
                break;
            default:
                src = 'Money-Payments-Finance - Finance-Savings - saving-money-egg';
                break;
        }
        return src+'.svg';
    },
    getIconIsInAnswers: (state) => icon => {
        // let it = state.in.filter(inItem => (inItem.answer.icon+'.svg') == icon);
        // return (it.length > 0);
        // console.log("ICON");
        // console.log(icon);
        for(let i=0; i < state.in.length; i++){
            // /icons/cloud/Building-Construction Houses house-modern.svg
            // "Building-Construction Houses house-modern"

            if(state.in[i].answer !== undefined && (state.in[i].answer.icon+'.svg' == icon)) {
                return true;
            }
            if(state.in[i].answers !== undefined && state.in[i].answers.length > 0) {
                for(let j=0; j < state.in[i].answers.length; j++){
                    if((state.in[i].answers[j].icon+'.svg') == icon){
                        return true;
                    }
                }
            }
        }
        return false;
    }
};

const actions = {
    setIcons4pdf: ({commit},icons4pdf) => {
        commit('SET_ICONS4PDF',icons4pdf);
    },
    updateCloudIconColors: ({state}) => {

    },
    setAnswer: ({commit},answerSet) => {
        commit('SET_ANSWER',answerSet);
    },
    setSingleChoiceSelection: ({commit},answerSet) => {
        commit('SET_SINGLE_CHOICE_SELECTION',answerSet);
    },
    setMultipleChoiceSelection: ({commit},answerSet) => {
        commit('SET_MULTIPLE_CHOICE_SELECTION',answerSet);
    },
    setReactiveIcons: ({commit},index) => {
        // Vorläufig: Nur für Frage 5 (index==5) im Einsatz
        // Maßgeblich ist die Antwort auf die Frage 5
        let src = 'Building-Construction Houses house-modern_grey';
        let tmp = state.in.filter(inItem => inItem.index == index);
        if(tmp == undefined || tmp[0] == undefined || tmp[0].answer.index=='') { return src+'.svg'; }
        let idx = tmp[0].answer.index;  // z.B. 5.1 für Miete
        switch(idx){
            case '5.1':
                src = 'Building-Construction - Buildings - buildings-1';
                break;
            case '5.2':
                src = 'Building-Construction Buildings building-1';
                break;
            case '5.3':
                src = 'Building-Construction Houses house-modern';
                break;
            case '5.4':
                src = 'Building-Construction Houses house-user';
                break;
            case '5.5':
                src = 'Building-Construction Buildings building-2';
                break;
            default:
                src = 'Building-Construction Houses house-modern_grey';
                break;
        }
        commit('SET_RESPONSIVE_ICON_SOURCE',{index: index, src: src});
    },
    /**
     * ******** IN DEVELOPMENT (no valid response) ****************
     * Toggle the selected state of ...
     * Example:
     *  - questionIndexString eq 5.2.1 means: Question 5, Subquestion 2, Subsubquestion 1
     *  - selectedOptionIndex eq 2 means: second item in array items, so: items[1]
     * @param commit
     * @param indexString
     * @returns {boolean}
     */
    setSelectionByIndexString: ({commit},answerSet) => {
        let questionIndexString = answerSet.indexString + ''; // must be string
        let selectedOptionIndex = answerSet.optionIndex + ''; // dito
        let indexes = questionIndexString.split('.');
        let currLevel = indexes.length;
        if(currLevel==1){
            if(indexes[0] < 1) { return false; }
            // Example: 5 , 2 => click at Eigentumswohnung (condo) (second options.item in out 5
            let target = state.out[indexes[0]-1].options.items[selectedOptionIndex-1];
            target.selected = !target.selected; // toggle state
        }
        else if(currLevel==2){
            if(indexes[0] < 1 || indexes[1] < 1) { return false; }
            // Example: 5.2.1 , 2 => click at nein (second options.item in subquestion 1 of options.item 2 of question 5
            // Hint: 5.2 does not have option.items but it has subquestions instead
            let question = state.out[indexes[0]-1].options.items[indexes[1]-1];
            let target = question.options.items[selectedOptionIndex-1];
            target.selected = !target.selected;
        }
        else if(currLevel==3){
            if(indexes[0] < 1 || indexes[1] < 1 || indexes[2] < 1) { return false; }
            // return state.out[indexes[0]-1].childQuestions[indexes[1]-1].childQuestions[indexes[2]-1];
            // Example: 5.2.
        }
    },
    storeMultipleSelection: ({commit},answerSet) => {
        commit('STORE_MULTIPLE_SELECTION',answerSet);
    },
    setRecommendedProducts: ({state,commit} ) => {
        // 1. Set/Update points by answers
        let productKey = ''; // Spalte in der Excel
        let points = 0; // Summe pro Produktspalte
        let optionIndexString = '';
        let indexes = [];
        let currLevel = 0;
        let qPoints = new Object();    // Punkte-Objekt der Antwortoption
        for(let i=0; i < state.products.length; i++){
            productKey = state.products[i].col; // Spalte in der Excel
            points = 0; // Summe pro Produktspalte
            optionIndexString = '';
            indexes = [];
            currLevel = 0;
            qPoints = {};
            for(let j=0; j < state.in.length; j++){
                if(state.in[j].answer !== undefined && state.in[j].answer.index!=undefined){
                    optionIndexString = state.in[j].answer.index;
                    if(optionIndexString==undefined) {
                        continue;
                    }
                    indexes = optionIndexString.split('.');
                    currLevel = indexes.length;
                    if(currLevel==2){
                        if(indexes[0] < 1 || indexes[1] < 1) { console.log('SPEZIAL: Abbruch weil Index ungültig auf Ebene 2' + "(" + state.products[i].label + ")"); continue; }
                        qPoints = Object.assign({},state.out[indexes[0]-1].options.items[indexes[1]-1].points);
                    }
                    else if(currLevel==3){
                        if(indexes[0] < 1 || indexes[1] < 1 || indexes[2] < 1) { console.log('SPEZIAL: Abbruch weil Index ungültig auf Ebene 3' + "(" + state.products[i].label + ")"); return false; }
                        qPoints = Object.assign({},state.out[indexes[0]-1].options.items[indexes[1]-1].options.items[indexes[2]-1].points);
                    }
                    else if(currLevel==4){
                        if(indexes[0] < 1 || indexes[1] < 1 || indexes[2] < 1 || indexes[3] < 1) { console.log('SPEZIAL: Abbruch weil Index ungültig auf Ebene 4' + "(" + state.products[i].label + ")"); return false; }
                        qPoints = Object.assign({},state.out[indexes[0]-1].options.items[indexes[1]-1].childQuestions[indexes[2]-1].options.items[indexes[3]-1].points);
                    }
                    else { qPoints = {}; }
                    if(qPoints[productKey] != undefined){
                        points += qPoints[productKey];
                    }
                }
                if(state.in[j].answers !== undefined && state.in[j].answers.length > 0){
                    for(let k=0; k < state.in[j].answers.length; k++){
                        optionIndexString = state.in[j].answers[k].index;
                        if(optionIndexString==undefined) { continue; }
                        indexes = optionIndexString.split('.');
                        currLevel = indexes.length;
                        if(currLevel==2){
                            if(indexes[0] < 1 || indexes[1] < 1) { console.log('SPEZIAL: Abbruch weil Indexes ungültig auf Ebene 2' + "(" + state.products[i].label + ")"); continue; }
                            qPoints = Object.assign({},state.out[indexes[0]-1].options.items[indexes[1]-1].points);
                        }
                        else if(currLevel==3){
                            if(indexes[0] < 1 || indexes[1] < 1 || indexes[2] < 1) { console.log('SPEZIAL: Abbruch weil Indexes ungültig auf Ebene 3' + "(" + state.products[i].label + ")"); return false; }
                            qPoints = Object.assign({},state.out[indexes[0]-1].options.items[indexes[1]-1].options.items[indexes[2]-1].points);
                        }
                        else if(currLevel==4){
                            if(indexes[0] < 1 || indexes[1] < 1 || indexes[2] < 1 || indexes[3] < 1) { console.log('SPEZIAL: Abbruch weil Indexes ungültig auf Ebene 3' + "(" + state.products[i].label + ")"); return false; }
                            qPoints = Object.assign({},state.out[indexes[0]-1].options.items[indexes[1]-1].childQuestions[indexes[2]-1].options.items[indexes[3]-1].points);
                        }
                        else { qPoints = {}; }
                        if(qPoints[productKey] != undefined){
                            points += qPoints[productKey];
                        }
                    }
                }
                else {
                    //
                }
            }
            state.products[i].points = points;
        }
        // sort by points and commit recommendations
        let tmp = state.products.sort(function(a,b){
            return b.points - a.points;
        });
        commit('SET_RECOMMENDATIONS', tmp);
    },
    /**
     * Entfernt aus state.in die Antworten, deren übergeordnete
     * Antworten nicht mehr vorhanden sind (z.B. Öltank muss
     * entfernt werden, wenn statt eigenes Haus Eigentumswohnung
     * gewählt wird.
     * @param state
     */
    removeResponseWithoutParents: ({state}) => {
        let candidate = {};
        let potParent = {};
        let checkerA = "";
        let checkerALevels = [];
        let levelA = 0;
        let isMultipleChoice = false; // isArray(answerSet.selection);
        let searchAnswerIndex = "x";
        let searchOptionIndex = "x.y";
        let responseCounter = 0;
        for (let i = 0; i < state.in.length; i++) {
            candidate = state.in[i];
            checkerA = candidate.index;
            if(checkerA==undefined || checkerA=="" || typeof checkerA != 'string') { continue; }
            checkerALevels = checkerA.split('.');
            levelA = checkerALevels.length;
            if(levelA == 3){
                searchAnswerIndex = checkerALevels[0];
                searchOptionIndex = searchAnswerIndex + '.' + checkerALevels[1];
                responseCounter = 0;
                for (let j=0; j < state.in.length; j++){
                    if(j==i) { continue; } // kein Vergleich mit sich selber
                    potParent = state.in[j];
                    if(potParent.index != searchAnswerIndex) { continue; }
                    isMultipleChoice = (potParent.answers != undefined && potParent.answers.length > 0);
                    if(potParent.answer != undefined && potParent.answer.index != undefined){
                        if(potParent.answer.index == searchOptionIndex){
                            responseCounter++;
                        }
                    }
                    else if(potParent.answers != undefined && potParent.answers.length > 0){
                        for(let l=0; l < potParent.answers.length; l++) {
                            if (potParent.answers[l].index == searchOptionIndex) {
                                responseCounter++;
                            }
                        }
                    }
                }
                if(responseCounter == 0) {
                    Vue.delete(state.in,i);
                }
            }
        }
    }
};



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
